export enum CountryCode {
    af = 'af',
    al = 'al',
    dz = 'dz',
    as = 'as',
    ad = 'ad',
    ao = 'ao',
    ai = 'ai',
    aq = 'aq',
    ag = 'ag',
    ar = 'ar',
    am = 'am',
    aw = 'aw',
    au = 'au',
    at = 'at',
    az = 'az',
    bs = 'bs',
    bh = 'bh',
    bd = 'bd',
    bb = 'bb',
    by = 'by',
    be = 'be',
    bz = 'bz',
    bj = 'bj',
    bm = 'bm',
    bt = 'bt',
    bo = 'bo',
    bq = 'bq',
    ba = 'ba',
    bw = 'bw',
    bv = 'bv',
    br = 'br',
    io = 'io',
    bn = 'bn',
    bg = 'bg',
    bf = 'bf',
    bi = 'bi',
    cv = 'cv',
    kh = 'kh',
    cm = 'cm',
    ca = 'ca',
    ky = 'ky',
    cf = 'cf',
    td = 'td',
    cl = 'cl',
    cn = 'cn',
    cx = 'cx',
    cc = 'cc',
    co = 'co',
    km = 'km',
    cd = 'cd',
    cg = 'cg',
    ck = 'ck',
    cr = 'cr',
    hr = 'hr',
    cu = 'cu',
    cw = 'cw',
    cy = 'cy',
    cz = 'cz',
    ci = 'ci',
    dk = 'dk',
    dj = 'dj',
    dm = 'dm',
    do = 'do',
    ec = 'ec',
    eg = 'eg',
    sv = 'sv',
    gq = 'gq',
    er = 'er',
    ee = 'ee',
    sz = 'sz',
    et = 'et',
    fk = 'fk',
    fo = 'fo',
    fj = 'fj',
    fi = 'fi',
    fr = 'fr',
    gf = 'gf',
    pf = 'pf',
    tf = 'tf',
    ga = 'ga',
    gm = 'gm',
    ge = 'ge',
    de = 'de',
    gh = 'gh',
    gi = 'gi',
    gr = 'gr',
    gl = 'gl',
    gd = 'gd',
    gp = 'gp',
    gu = 'gu',
    gt = 'gt',
    gg = 'gg',
    gn = 'gn',
    gw = 'gw',
    gy = 'gy',
    ht = 'ht',
    hm = 'hm',
    va = 'va',
    hn = 'hn',
    hk = 'hk',
    hu = 'hu',
    is = 'is',
    in = 'in',
    id = 'id',
    ir = 'ir',
    iq = 'iq',
    ie = 'ie',
    im = 'im',
    il = 'il',
    it = 'it',
    jm = 'jm',
    jp = 'jp',
    je = 'je',
    jo = 'jo',
    kz = 'kz',
    ke = 'ke',
    ki = 'ki',
    kp = 'kp',
    kr = 'kr',
    kw = 'kw',
    kg = 'kg',
    la = 'la',
    lv = 'lv',
    lb = 'lb',
    ls = 'ls',
    lr = 'lr',
    ly = 'ly',
    li = 'li',
    lt = 'lt',
    lu = 'lu',
    mo = 'mo',
    mg = 'mg',
    mw = 'mw',
    my = 'my',
    mv = 'mv',
    ml = 'ml',
    mt = 'mt',
    mh = 'mh',
    mq = 'mq',
    mr = 'mr',
    mu = 'mu',
    yt = 'yt',
    mx = 'mx',
    fm = 'fm',
    md = 'md',
    mc = 'mc',
    mn = 'mn',
    me = 'me',
    ms = 'ms',
    ma = 'ma',
    mz = 'mz',
    mm = 'mm',
    na = 'na',
    nr = 'nr',
    np = 'np',
    nl = 'nl',
    nc = 'nc',
    nz = 'nz',
    ni = 'ni',
    ne = 'ne',
    ng = 'ng',
    nu = 'nu',
    nf = 'nf',
    mp = 'mp',
    no = 'no',
    om = 'om',
    pk = 'pk',
    pw = 'pw',
    ps = 'ps',
    pa = 'pa',
    pg = 'pg',
    py = 'py',
    pe = 'pe',
    ph = 'ph',
    pn = 'pn',
    pl = 'pl',
    pt = 'pt',
    pr = 'pr',
    qa = 'qa',
    mk = 'mk',
    ro = 'ro',
    ru = 'ru',
    rw = 'rw',
    re = 're',
    bl = 'bl',
    sh = 'sh',
    kn = 'kn',
    lc = 'lc',
    mf = 'mf',
    pm = 'pm',
    vc = 'vc',
    ws = 'ws',
    sm = 'sm',
    st = 'st',
    sa = 'sa',
    sn = 'sn',
    rs = 'rs',
    sc = 'sc',
    sl = 'sl',
    sg = 'sg',
    sx = 'sx',
    sk = 'sk',
    si = 'si',
    sb = 'sb',
    so = 'so',
    za = 'za',
    gs = 'gs',
    ss = 'ss',
    es = 'es',
    lk = 'lk',
    sd = 'sd',
    sr = 'sr',
    sj = 'sj',
    se = 'se',
    ch = 'ch',
    sy = 'sy',
    tw = 'tw',
    tj = 'tj',
    tz = 'tz',
    th = 'th',
    tl = 'tl',
    tg = 'tg',
    tk = 'tk',
    to = 'to',
    tt = 'tt',
    tn = 'tn',
    tr = 'tr',
    tm = 'tm',
    tc = 'tc',
    tv = 'tv',
    ug = 'ug',
    ua = 'ua',
    ae = 'ae',
    gb = 'gb',
    um = 'um',
    us = 'us',
    uy = 'uy',
    uz = 'uz',
    vu = 'vu',
    ve = 've',
    vn = 'vn',
    vg = 'vg',
    vi = 'vi',
    wf = 'wf',
    eh = 'eh',
    ye = 'ye',
    zm = 'zm',
    zw = 'zw',
    ax = 'ax',
    xk = 'xk',
}

export const CountryCodes = Object.keys(CountryCode) as CountryCode[];

export const isCountryCode = (x: unknown): x is CountryCode => typeof x === 'string' && CountryCodes.includes(x as CountryCode);

export const IncompleteCountries: CountryCode[] = [
  CountryCode.aq,
  CountryCode.bv,
  CountryCode.io,
  CountryCode.tf,
  CountryCode.hm,
  CountryCode.gs,
  CountryCode.um,
  CountryCode.cc,
  CountryCode.gg,
  CountryCode.im,
  CountryCode.je,
  CountryCode.nf,
  CountryCode.sj,
  CountryCode.ax,
  CountryCode.xk,
  CountryCode.bq,
  CountryCode.bl,
  CountryCode.mf,
  CountryCode.pm,
];

export function randomCountry(): CountryCode {
  const countries = CountryCodes.filter((code) => !IncompleteCountries.includes(code));
  return countries[Math.floor(Math.random() * countries.length)];
}
